<section id="console" class="console" [hidden]="!isLocal">
  <a href="javascript:void(0)" class="closebtn" (click)="toggleHide()">c</a>
  <div class="row py-3"></div>
  <div class="row">
    <div class="col-4 my-1">
      <jhi-bary-button color="grey" (clickEvent)="billRobot('today')" size="sm" label="BILL ROBOT (TODAY)"></jhi-bary-button>
    </div>
    <div class="col-4 my-1">
      <jhi-bary-button color="grey" (clickEvent)="billRobot('week')" size="sm" label="BILL ROBOT (END OF WEEK)"></jhi-bary-button>
    </div>
    <div class="col-4 my-1">
      <jhi-bary-button color="grey" (clickEvent)="billRobot('month')" size="sm" label="BILL ROBOT (END OF MONTH)"></jhi-bary-button>
    </div>
    <div class="col-4 my-1">
      <jhi-bary-button color="blue" (clickEvent)="pushLastTask()" size="sm" label="Push last task"></jhi-bary-button>
    </div>
    <div class="col-4 my-1">
      <jhi-bary-button color="green" (clickEvent)="addGeneralTransportToBasket()" size="sm" label="Add general transport to basket"></jhi-bary-button>
    </div>
    <div class="col-4 my-1">
      <jhi-bary-button color="green" (clickEvent)="addAdrTransportToBasket()" size="sm" label="Add ADR transport to basket"></jhi-bary-button>
    </div>
  </div>
</section>
